<template>
	<ul class="my-bookmark__list">
		<bookmark-item v-for="post in postList"
			:post="post" :bookmark="bookmark"
			@delete="onBookmarkDelete"></bookmark-item>
	</ul>
</template>

<script>
	import BookmarkItem from './BookmarkItem.vue';

	export default {
		components: { BookmarkItem },

		props: ['postList', 'bookmark'],

		methods: {
			onBookmarkDelete: function (permLink, tagIds) {
				this.$emit('delete', permLink, tagIds);
			}
		},
	}
</script>
